import { WorkflowTask } from "./workflow-task";

export class WorkflowTaskListComparison {
  before: WorkflowTask[];
  after: WorkflowTask[];

  public constructor(before: WorkflowTask[], after: WorkflowTask[]) {
    this.before = before;
    this.after = after;
  }
}